import { Component, OnInit } from '@angular/core';
import { ActivityView } from 'src/app/views/master-views/app.view/app.view.component';

@Component({
    selector: 'wm-contractor-renewal-decision-activity-view',
    templateUrl: './contractor-renewal-decision-activity-view.component.html',
    styleUrls: ['./contractor-renewal-decision-activity-view.component.css'],
    standalone: false
})
export class ContractorRenewalDecisionActivityViewComponent extends ActivityView
  implements OnInit {
  constructor() {
    super();
  }

  ngOnInit() {}
}
